<template>
  <v-card class="full-height" id="groups-container">
    <v-card-title>
      <span>Groupes |</span>
      <v-skeleton-loader
        type="card-heading"
        v-if="nbResults < 0 || global.totalGroups < 0"
      ></v-skeleton-loader>
      <span v-else class="ml-1 text-body-1">
        {{ nbResults }} / {{ global.totalGroups }}
      </span>
      <v-spacer></v-spacer>
      <v-btn
        v-if="isAdmin()"
        color="primary"
        icon
        @click.stop="createGroupDialog = true"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <create-group-dialog
        :open.sync="createGroupDialog"
        v-if="createGroupDialog && isAdmin()"
      ></create-group-dialog>
    </v-card-title>
    <v-divider></v-divider>
    <filtres-group :criteria.sync="criteriaGroup"></filtres-group>
    <v-divider></v-divider>
    <v-card-text>
      <div id="table-groupes-container">
        <group-datatable
          :searchTerm="searchTerm"
          v-on:display:nb-groups="updateNbResults"
          :criteria="criteriaGroup"
        ></group-datatable>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
import CreateGroupDialog from "@/components/Group/CreateGroupDialog";
import GroupDatatable from "@/components/Group/GroupDatatable";
import FiltresGroup from "@/components/Group/FiltresGroup";
import { ref, toRefs } from "@vue/composition-api";
import { useGroup } from "@/composables/group.js";
import { useTitle } from "@/composables/title.js";
import global from "@/composables/global";
import { useRoles } from "../composables/roles";

export default {
  components: {
    GroupDatatable,
    CreateGroupDialog,
    FiltresGroup,
  },
  setup() {
    /* Import des API */
    const { criteriaGroup, data } = useGroup();
    const { setTitle, setIcon } = useTitle();
    const { isAdmin } = useRoles();

    /* Variables */
    let searchTerm = ref("");
    let searchText = ref("");
    const nbResults = ref(-1);

    /* Méthodes */
    function updateSearchTerm() {
      searchTerm.value = searchText.value;
    }
    const updateNbResults = function (value) {
      nbResults.value = value;
    };

    /* Actions */
    setTitle("Groupes");
    setIcon("groupes");

    return {
      searchTerm,
      searchText,
      updateSearchTerm,
      nbResults,
      updateNbResults,
      criteriaGroup,
      global,
      ...toRefs(data),
      isAdmin,
    };
  },
};
</script>
